import { token } from '@atlaskit/tokens';

import type { AIAppsCollectionConfig } from './types';

import AdminToolsIcon from '../assets/aiCollectionAssets/admin-tools-vector.svg';
import ContentAndCommunicationIcon from '../assets/aiCollectionAssets/content-vector.svg';
import ITSupportAndServiceIcon from '../assets/aiCollectionAssets/it-support-vector.svg';
import ProjectManagementIcon from '../assets/aiCollectionAssets/project-management-vector.svg';

export const aiCollectionConfig: AIAppsCollectionConfig = {
  id: 'artificial-intelligence',
  title: 'AI where you want it, when you need it',
  description:
    'Get more done, faster, with AI apps that streamline testing, planning, support, and documentation for your team.',
  categories: [
    {
      id: 'Administrative tools',
      label: 'Admin tools',
      icon: AdminToolsIcon,
      tabAriaLabel: 'Switch to admin tools apps',
      title: 'Accelerate admin tasks with AI agility',
      description: 'Harness AI-driven insights to make every admin task smarter and seamless.',
      linkText: 'Explore all apps',
      linkHref: '/collections/artificial-intelligence?categories=Administrative+tools',
      linkAriaLabel: 'Open the full list of available admin tools apps',
      clipPath: {
        mobile:
          'polygon( 0% 0%,4.666% 0.238%,6.55% 0.335%,16.695% 0.853%,18.493% 0.945%,50% 2.555%,75% 3.833%,87.5% 4.471%,100% 4.471%,100% 9.833%,100% 15.422%,100% 25.733%,100% 46.357%,100% 100%,0% 95.133%,0% 0% )',
        desktop:
          'polygon( 0% 0%,4.666% 0.272%,6.55% 0.382%,16.695% 0.974%,18.493% 1.079%,50% 2.917%,75% 4.375%,87.5% 5.104%,93.75% 5.469%,96.812% 11.806%,100% 17.604%,100% 29.375%,100% 52.917%,100% 100%,0% 94.444%,0% 0% )',
      },
      backgroundColor: '#FCA700',
      textColor: token('color.text'),
    },
    {
      id: 'Content and communication',
      label: 'Content',
      icon: ContentAndCommunicationIcon,
      tabAriaLabel: 'Switch to content apps',
      title: 'Create content that clicks',
      description:
        'Turn videos into clear summaries, transform ideas into polished help articles, add impactful alt-text captions, and keep every document sharp and consistent.',
      linkText: 'Explore all apps',
      linkHref: '/collections/artificial-intelligence?categories=Content+and+communication',
      linkAriaLabel: 'Open the full list of available content apps',
      clipPath: {
        mobile:
          'polygon( 0% 6.384%,73.329% 0%,100% 10.137%,100% 46.505%,100% 100%,0% 93.688%,0% 6.384% )',
        desktop:
          'polygon( 0% 16.71%,70.077% 0%,75% 11.504%,87.5% 12.179%,93.75% 12.516%,96.812% 18.38%,100% 23.747%,100% 34.64%,100% 56.427%,100% 100%,0% 94.859%,0% 16.71% )',
      },
      backgroundColor: '#82B536',
      textColor: token('color.text'),
    },
    {
      id: 'Project management',
      label: 'Project management',
      icon: ProjectManagementIcon,
      tabAriaLabel: 'Switch to project management apps',
      title: 'Ship better plans, faster',
      description:
        'Let AI handle your release notes, user stories, acceptance criteria, and project summaries, so your team does less drafting and more delivering.',
      linkText: 'Explore all apps',
      linkHref: '/collections/artificial-intelligence?categories=Project+management',
      linkAriaLabel: 'Open the full list of available project management apps',
      clipPath: {
        mobile:
          'polygon( 0% 0%,75% 4.599%,100% 7.892%,100% 18.505%,100% 30.879%,100% 55.626%,100% 100%,0% 99.28%,0% 0% )',
        desktop:
          'polygon( 0% 0%,50% 2.917%,75% 4.375%,87.5% 5.104%,93.75% 5.469%,96.812% 11.806%,100% 17.604%,100% 29.375%,100% 52.917%,100% 100%,0% 94.444%,0% 0% )',
      },
      backgroundColor: '#BF63F3',
      textColor: token('color.text'),
    },
    {
      id: 'IT support and service',
      label: 'IT',
      icon: ITSupportAndServiceIcon,
      tabAriaLabel: 'Switch to IT apps',
      title: 'Drive compliance with ease',
      description:
        'Quickly spot SLA bottlenecks, capture structured data from tickets and screenshots, and manage AI usage to keep every workflow secure and efficient.',
      linkText: 'Explore all apps',
      linkHref: '/collections/artificial-intelligence?categories=IT+support+and+service',
      linkAriaLabel: 'Open the full list of available IT support and service apps',
      clipPath: {
        mobile:
          'polygon( 0% 0%,50.817% 0%,75.534% 11.339%,87.767% 12.139%,93.883% 12.538%,100% 12.538%,100% 25.837%,100% 38.737%,99.623% 67.732%,99.623% 100%,0% 96.651%,0% 0% )',
        desktop:
          'polygon( 0.042% 0.126%,50.838% 0.126%,75.544% 9.533%,87.772% 10.196%,93.886% 10.527%,100% 10.527%,100% 21.559%,100% 32.26%,99.623% 56.313%,98.032% 99.874%,4.313% 92.298%,0.042% 0.126% )',
      },
      backgroundColor: token('color.background.brand.bold'),
      textColor: token('color.text.inverse'),
    },
  ],
};
